import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { NetworkCallService } from 'src/app/core/services/network-call.service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { IRegistrationLoginRequest, IRegistrationLoginSuccess } from '../models/registration-login.model';
import * as register from '../actions/register.actions';
import { SessionStorageIds } from '../../../shared/enums';

@Injectable()
export class RegisterEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService,
  ) {}

  register$ = createEffect(() =>
    this.actions$.pipe(
      ofType(register.loadRegisterRequest),
      switchMap(action =>
        this.networkCallService.post<IRegistrationLoginRequest, IRegistrationLoginSuccess>('/Authentication/register', action.request).pipe(
          map(response => {
            if (response.success && response.accessToken !== null) {
              sessionStorage.setItem(SessionStorageIds.USER_MOBILE, action.request.mobileNumber);
              sessionStorage.setItem('token', response.accessToken);
              sessionStorage.setItem('refreshToken', response.refreshToken);
              this.helperService.decodeJwtToken(response.accessToken);
              this.router.navigateByUrl('auth/marketing-options');
            }
            return register.loadRegisterSuccess({ response });
          }),
          retryTransientHttpErrors(),
          catchError(error => {
            return of(register.loadRegisterFailure(error));
          })
        )
      )
    )
  );
}
